import { render, staticRenderFns } from "./HomeworkReplies.vue?vue&type=template&id=5c217c32&scoped=true&"
import script from "./HomeworkReplies.vue?vue&type=script&lang=js&"
export * from "./HomeworkReplies.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkReplies.vue?vue&type=style&index=0&id=5c217c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c217c32",
  null
  
)

export default component.exports